import type { GameSnapshot } from '../core/types';

export interface FrameDiagnostics {
  fps: number;
  frameTime: number;
  fixedStepsLastFrame: number;
}

export interface PresetDiagnostics {
  readonly physics: string;
  readonly visual: string;
}

export class DebugPanel {
  public constructor(
    private readonly element: HTMLOutputElement,
    enabled: boolean,
    private readonly presets: PresetDiagnostics,
  ) {
    element.hidden = !enabled;
  }

  public update(snapshot: Readonly<GameSnapshot>, frame: Readonly<FrameDiagnostics>): void {
    if (this.element.hidden) return;
    const diagnostics = snapshot.diagnostics;
    this.element.textContent = [
      `seed     ${snapshot.seed}`,
      `presets  ${this.presets.physics} / ${this.presets.visual}`,
      `chunk    ${snapshot.currentChunk || '—'}`,
      `phase    ${snapshot.phase}`,
      `lane     ${snapshot.player.lane} (${snapshot.player.action})`,
      `speed    ${snapshot.speed.toFixed(2)} u/s`,
      `distance ${snapshot.distance.toFixed(1)} m`,
      `score    ${snapshot.score}`,
      `fps      ${frame.fps.toFixed(0)} (${frame.frameTime.toFixed(1)} ms)`,
      `steps    ${frame.fixedStepsLastFrame} / ${diagnostics.fixedUpdates}`,
      `chunks   ${diagnostics.activeChunks} active · ${diagnostics.pooledChunks} pooled`,
      `hazards  ${diagnostics.activeObstacles} active · ${diagnostics.pooledObstacles} pooled`,
      `coins    ${diagnostics.activeCoins} active · ${diagnostics.pooledCoins} pooled`,
    ].join('\n');
  }
}
